import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Pageview from "@material-ui/icons/Pageview";
import Check from "@material-ui/icons/Check";

// material-ui components
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from "@material-ui/core/Checkbox";

// core components
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import CardBody from "beaktShared/components/Card/CardBody.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Pagination from "beaktShared/components/Pagination/Pagination.js";
import HeaderVenda from 'beaktClinic/views/Venda/Header/HeaderVenda';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1} from "beaktShared/helpers/masks";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple,UsePostApi } from "beaktShared/services/crudeApiService";
import { initCarrinho, setcarrinhoVendaCookie, getcarrinhoVendaCookie } from "beaktClinic/services/carrinhoVenda";

// style
import "beaktShared/components/CustomInput/rotate.css";
import styles from "assets/jss/BeaktClinic/views/Venda/venda.js";
import stylesMaterial from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { makeStyles } from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
  
const useStyles = makeStyles(styles);
const useStylesMaterial = makeStyles(stylesMaterial);

export default function Venda() {
   const { t } = useTranslation();
   const classes = useStyles();     
   const classesMaterial = useStylesMaterial();

   const session = useContext(SessionContext);
   const { register, errors , setValue } = useForm({mode: "onBlur"}); 
  
   const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
   });
   const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 6000);       
   };
   
   const [pages, setPages] = React.useState([]);
   const [pageNumber, setpageNumber] = React.useState(1);   
   const [descricaoPesquisa, setdescricaoPesquisa] = React.useState("");

   useEffect(() => {  
    loadEspecialidades();
    loadprodutoGrupos();
    inicializaCarrinho();
   }, []);

   useEffect(() => { 
        loadItensVenda(tipochecked,especialidadechecked,produtoGruposchecked,descricaoPesquisa,pageNumber);
    }, [pageNumber]);
   
   const inicializaCarrinho = () =>{
    let carrinhoVenda = getcarrinhoVendaCookie();
    if(carrinhoVenda === null)
    {
        carrinhoVenda = {
            ...initCarrinho,
            usuarioCadastroId:session.id,
            estabelecimentoId:session.estabelecimentoId
        };     
    }
    setcarrinhoVendaCookie(carrinhoVenda);
   }
   
   const [tipochecked,settipochecked] = React.useState([]);
   const handleChangeCheckTipo = (e,tipo) => {
        let newlistUpdated = "";
        if(e.target.checked)
        {
            //adiciona             
            newlistUpdated = [...tipochecked, tipo];
            settipochecked(newlistUpdated);  
        }
        else
        {
            //remove 
            newlistUpdated = tipochecked.filter(obj => {
                return obj !== tipo;
            });
            settipochecked(newlistUpdated); 
        }
        loadItensVenda(newlistUpdated,especialidadechecked,produtoGruposchecked,descricaoPesquisa,1);
   }   
  
   const [especialidadesLoading,setespecialidadesLoading] = React.useState(false);
   const [especialidades,setespecialidades] = React.useState([]);
   const [especialidadechecked,setespecialidadechecked] = React.useState([]);
   const loadEspecialidades = () =>{      
     setespecialidadesLoading(true);
     const endPoint = "especialidades/byestabelecimentotosell/" + session.estabelecimentoId;
     UseGetApiSimple(endPoint,0).then(result=>{       
         if(result.status !== 200)
         {                                     
             showNotification(result.message,'danger');    
             setespecialidadesLoading(false);
             return false; 
         }
         setespecialidades(result.data);    
         setespecialidadesLoading(false);
         return true;
     }); 
   }
   const handleChangeCheckEspecialidade = (e,id) =>{
    let newlistUpdated = "";
     if(e.target.checked)
     {
       //adiciona 
         let listFiltered = especialidades.filter(obj => {
             return obj.especialidadeId === id;
         });
         
         newlistUpdated = [...especialidadechecked, listFiltered[0]];
         setespecialidadechecked(newlistUpdated);  
     }
     else
     {
         //remove 
         newlistUpdated = especialidadechecked.filter(obj => {
             return obj.especialidadeId !== id;
         });
         setespecialidadechecked(newlistUpdated); 
     }
     loadItensVenda(tipochecked,newlistUpdated,produtoGruposchecked,descricaoPesquisa,1);
   }   
 
   const [produtoGruposLoading,setprodutoGruposLoading] = React.useState(false);
   const [produtoGrupos,setprodutoGrupos] = React.useState([]);
   const [produtoGruposchecked,setprodutoGruposchecked] = React.useState([]);
   const loadprodutoGrupos = () =>{      
     setprodutoGruposLoading(true);
     const endPoint = "produtogrupos/byestabelecimentotosell/" + session.estabelecimentoId;
     UseGetApiSimple(endPoint,0).then(result=>{       
         if(result.status !== 200)
         {                                     
             showNotification(result.message,'danger');    
             setprodutoGruposLoading(false);
             return false; 
         }
         setprodutoGrupos(result.data);    
         setprodutoGruposLoading(false);
         return true;
     }); 
   }
   const handleChangeCheckProdutoGrupos = (e,id) =>{
    let newlistUpdated = "";
     if(e.target.checked)
     {
       //adiciona 
         let listFiltered = produtoGrupos.filter(obj => {
             return obj.produtoGrupoId === id;
         });
         
         newlistUpdated = [...produtoGruposchecked, listFiltered[0]];
         setprodutoGruposchecked(newlistUpdated);  
     }
     else
     {
         //remove 
         newlistUpdated = produtoGruposchecked.filter(obj => {
             return obj.produtoGrupoId !== id;
         });
         setprodutoGruposchecked(newlistUpdated); 
     }
     loadItensVenda(tipochecked,especialidadechecked,newlistUpdated,descricaoPesquisa,1);
   }

   const handlePesquisarChange = (e) => {       
    let desc = e.target.value;  
    setdescricaoPesquisa(desc);
    if((desc.length >= 3 || desc.length === 0)){
        loadItensVenda(tipochecked,especialidadechecked,produtoGruposchecked,desc,1);
    }
   }

   const [itensVendaLoading,setitensVendaLoading] = React.useState(false);
   const [itensVenda,setitensVenda] = React.useState([]); 
   const loadItensVenda = (tipochecked2,especialidadechecked2,produtoGruposchecked2,descricaoPesquisa2,pageNumber2) => {
     setitensVendaLoading(true);

     let filter_especialidades = [];
     for(var i in especialidadechecked2)
        filter_especialidades.push(especialidadechecked2[i].especialidadeId);

     let filter_grupos = [];
     for(var i in produtoGruposchecked2)
        filter_grupos.push(produtoGruposchecked2[i].produtoGrupoId)
    
     let filter = {
        tipos: tipochecked2,
        especialidades: filter_especialidades,
        grupo_produtos: filter_grupos,
        descricao: descricaoPesquisa2
     }

     let numeropaginaenviar = pageNumber;
     if (pageNumber2 !== "")
        numeropaginaenviar =  pageNumber2;

     const endPoint = "vendas/itensavailabletosell/" + session.estabelecimentoId + "?PageNumber=" + numeropaginaenviar + "&PageSize=9";
     UsePostApi(endPoint,filter).then(result=>{
        if(result.status !== 200)
        {                                    
            showNotification(result.message,'danger');  
            setitensVendaLoading(false);
            return false; 
        }
        console.log(result.data);
        setitensVenda(result.data);
        let configure_pages = JSON.parse(result.headers["x-pagination"]);
        hangleloadPage(configure_pages);    
        setitensVendaLoading(false);
        return true;
     }); 
   }

   const hangleloadPage = (configure_pages) =>{       
        
        let _pages = [];
        if (configure_pages.HasPrevious)
            _pages.push({text: 'Anterior', onClick:handlePage});
        
        _pages.push({text: 1, active: (configure_pages.CurrentPage === 1 ? true : false), onClick:handlePage}); 
        
        let i = 2;
        let pagesadd = configure_pages.TotalPages;

        if (pagesadd > 6)
        {                        
            if (configure_pages.CurrentPage > 4){
                _pages.push({text: "...", active: false, onClick:function(){}});
                i = configure_pages.CurrentPage - 2;
            }
            if ((i + 4) < pagesadd)
                pagesadd = i + 4;
        }            

        for(i; i <= pagesadd; i++){
            _pages.push({text: i, active: (i === configure_pages.CurrentPage ? true : false), onClick:handlePage});            
        }
        
        if (configure_pages.TotalPages > pagesadd)
        {
            _pages.push({text: "...", active: false, onClick:function(){}});
            _pages.push({text: configure_pages.TotalPages, active: false, onClick:handlePage});
        }

        if (configure_pages.HasNext)
            _pages.push({text: 'Próximo', onClick:handlePage});         
            
        setPages(_pages);
   }

   const handlePage = (e) => {              
        let _pageNumber = pageNumber;      
        if(e === "Próximo")
            _pageNumber = pageNumber + 1;
        else if (e === "Anterior")
            _pageNumber = pageNumber - 1;
        else
            _pageNumber = parseInt(e);        
        setpageNumber(_pageNumber);
   }  

  const [showDetalhe,setshowDetalhe] = React.useState(false);
  const [detalhePacote,setdetalhePacote] = React.useState([]);
  const [showAddCar,setshowAddCar] = React.useState(false); 
  const [addItem,setaddItem] = React.useState({});

  const handleAdd = (item) =>{
    let carrinhoVenda = getcarrinhoVendaCookie();
    let itens = [...carrinhoVenda.itens, addItem];
    let itenstoFilter = carrinhoVenda.itens;
    
    let listFiltered = itenstoFilter.filter(obj => {
        return obj.id === item.id;
    });

    if(listFiltered.length > 0){
        showNotification('Este item já existe no carrinho, altere a quantidade dele no carrinho','info');  
        return;
    }
    else if(itens.length > 1){
        //serviços e pacotes que possuem clausula vinculada em seus cadastros somente poderão ser vendidos avulso no carrinho
        let itemPossuiClausula = itenstoFilter.filter(obj => {
            return obj.clausula != "";
        });

        if(itemPossuiClausula.length > 0){
            showNotification('O carrinho possui um item que tem cláusula de contrato específica, para adicionar outros itens, somente removendo o item existente no carrinho!','info');  
            return;
        }
        else if(item.clausula != ""){
            showNotification('Este item possui cláusula de contrato específica, e por isso só pode ser vendido sozinho, remova os demais itens existentes no carrinho para conseguir adicionar este!','info');  
            return;
        }
        
    }

    setaddItem({
        ...item,
        qtd:1,
        valorUnitario:item.valor,
        valorDesconto:0,
        valorTotal:item.valor,
        valorTotalComDesconto:item.valor
    });
    setshowAddCar(true);
}
  
  const handleChangeQtdItemAdd = (e) =>{
    let qtd = e.target.value;
    calculaTotalizadorByEvent(qtd, addItem.valorDesconto);  
  }

  const handleRestDescont = (e) =>{
    if(e.target.value === ""){
        e.target.value ="0,00"
        return; 
    }
  }
  
  const handleChangeDescontoItemAdd = (e) =>{
    let desconto = 0;
    if(e.target.value !== "")
        desconto = transformValueFormatedtoFloat(e.target.value);

    if(desconto>addItem.valorTotal)
    {
        desconto = addItem.valorTotal;
        e.target.value = transformValueFloattoFormated(desconto);
    }
    calculaTotalizadorByEvent(addItem.qtd,desconto);
  } 

  const calculaTotalizadorByEvent = (qtd,desconto) =>{
    let maximoLimiteDesconto = addItem.maximoLimiteDesconto;
    let total = addItem.valor * qtd;      
    let totalComDesconto = total - desconto;

    if (maximoLimiteDesconto !== null)
    {
        if (maximoLimiteDesconto < 100)
        {
            let valorLimiteMaximo = ((total * maximoLimiteDesconto) / 100);

            if (desconto > valorLimiteMaximo)
            {
                setValue("valorDesconto", "0,00");
                total = addItem.valor;
                totalComDesconto = addItem.valor;
                desconto = 0;
                showNotification('Valor de desconto superior ao limite permitido. Desconto não autorizado.','danger'); 
            }
        }
    }

    setaddItem({
        ...addItem,
        qtd:qtd,
        valorTotal: total,
        valorDesconto:desconto,
        valorTotalComDesconto:totalComDesconto
    });

  }
  
  const handleAddItemCarrinho = () =>{
    let carrinhoVenda = getcarrinhoVendaCookie();
    let itens = [...carrinhoVenda.itens, addItem];

    let itenstoFilter = carrinhoVenda.itens;
    let listFiltered = itenstoFilter.filter(obj => {
        return obj.id === addItem.id;
    }); 

    let qtdTotal = 0;
    itens.map(item =>{
        qtdTotal = qtdTotal + parseInt(item.qtd);
    });
    
    // Condição para validar se o prodto controle estoque
    if (itens.length > 0) {
        for (let i = 0; i < itens.length; i++) {
            const item = itens[i];
            if (addItem.id === item.id)
            {
                if (item.tipoItem === 0 && item.controlaEstoque === true) {
                    if (addItem.qtd > item.saldoEstoque) {
                        showNotification(
                            "O produto " +
                            item.descricao.toUpperCase() +
                            " controla estoque, e existe(m) " +
                            item.saldoEstoque +
                            " disponível(eis).",
                            "danger"
                        );
                        return; 
                    }
                }
            }
        }
    }

    carrinhoVenda = {
        ...carrinhoVenda,
        qtdItensTotalCarrinho: qtdTotal,
        itens:itens
    }    

    setcarrinhoVendaCookie(carrinhoVenda);
    setshowAddCar(false);
  }

  const loadDetalhePacote = (pacoteId) =>{
  
    setitensVendaLoading(true);
    const endPoint = "vendas/detailvendasell/" + pacoteId;
     UseGetApiSimple(endPoint).then(result=>{
        if(result.status !== 200)
        {                                    
            showNotification(result.message,'danger');    
            setitensVendaLoading(false);
            return false; 
        }    
        setdetalhePacote(result.data); 
        setitensVendaLoading(false);
        setshowDetalhe(true);
        return true;
     }); 
  }
  
  return (
    
    <div className="maxContent">     
         <Snackbar
            place="tr"
            color={notification.color}
            message={notification.message}
            open={notification.show}
            closeNotification={() => setNotification({show:false})}
            close
        />   
        
        <HeaderVenda></HeaderVenda>

        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>            
                <Card>
                    <CardBody>
                        <h6> {t('sale.type')} </h6>
                        <div className="sizeBoxFilter">
                        <div className="checkboxmi"> 
                            <Checkbox
                                tabIndex={-1}     
                                onChange={event => {handleChangeCheckTipo(event, "Produtos")}}                                             
                                checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                icon={<Check className={classesMaterial.uncheckedIcon} />}
                                classes={{ checked: classesMaterial.checked }}                    
                                name="ckproduto"                                                   
                            />
                            <label>{t('dashboard.products')}</label>   
                        </div>                          
                        <div className="checkboxmi">  
                            <Checkbox
                                tabIndex={-1}     
                                onChange={event => {handleChangeCheckTipo(event, "Serviços")}}                                             
                                checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                icon={<Check className={classesMaterial.uncheckedIcon} />}
                                classes={{ checked: classesMaterial.checked }}         
                                name="ckservicos"                                                   
                            />
                            <label>{t('dashboard.services')}</label>                                                      
                        </div> 
                        <div className="checkboxmi">   
                            <Checkbox
                                tabIndex={-1}     
                                onChange={event => {handleChangeCheckTipo(event, "Pacotes")}}                                             
                                checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                icon={<Check className={classesMaterial.uncheckedIcon} />}
                                classes={{ checked: classesMaterial.checked }}                     
                                name="Pacotes"                                                   
                            />   
                            <label> {t('dashboard.packages')}</label>                                                      
                        </div> 
                        </div>                        
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <h6>
                            {t('sale.specialties')}
                        </h6>
                        <div className="sizeBoxFilter">
                        {especialidadesLoading && <div className="loadingitemVenda">
                            <CircularProgress size={20}  />
                        </div>}
                        {especialidades.map(item => (   
                            <div key={item.especialidadeId}  className="checkboxmi">                               
                                <Checkbox
                                    tabIndex={-1}     
                                    onChange={event => {handleChangeCheckEspecialidade(event, item.especialidadeId)}}                                             
                                    checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                    icon={<Check className={classesMaterial.uncheckedIcon} />}
                                    classes={{ checked: classesMaterial.checked }}                    
                                    name={"ckespecialidade_" + item.especialidadeId}
                                />
                                <label>{item.descricao}</label>                                     
                            </div>  
                        ))}
                        </div>
                    </CardBody>
                </Card>
                <Card >
                    <CardBody>
                        <h6>
                            {t('sale.products_group')}
                        </h6>  
                        <div className="sizeBoxFilter">    
                        {produtoGruposLoading && <div className="loadingitemVenda">
                            <CircularProgress size={20}  />
                        </div>}
                        {produtoGrupos.map(item => (   
                            <div key={item.produtoGrupoId}  className="checkboxmi">                               
                                <Checkbox
                                    tabIndex={-1}     
                                    onChange={event => {handleChangeCheckProdutoGrupos(event, item.produtoGrupoId)}}                                             
                                    checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                    icon={<Check className={classesMaterial.uncheckedIcon} />}
                                    classes={{ checked: classesMaterial.checked }}                    
                                    name={"ckprodutoGrupos" + item.produtoGrupoId}
                                />
                                <label>{item.descricao}</label>                                 
                            </div>  
                        ))}
                        </div>
                    </CardBody>
                </Card>  
            </GridItem>
        
            <GridItem xs={12} sm={12} md={9}>
                
            <Card>
            <CardBody style={{minHeight:'600px'}}>  
                {itensVendaLoading && <div className="loadingVenda">
                    <CircularProgress />
                    <br/>
                    <label>{t('sale.loading_itens')}...</label>
                </div>}                          
                <GridContainer>   
                <GridItem md={12} xs={12} sm={12}>
                    <FormControl fullWidth style={{marginBottom:'15px'}} >                               
                        <TextField                                     
                            error={errors.pesquisar?true:false}
                            placeholder={t('label.research')+"..."}
                            variant="outlined"
                            onChange={handlePesquisarChange} 
                            inputRef={register({
                                maxLength: {
                                    value:50,
                                    message: t('information_message.enter_max_50_characteres')
                                }
                            })}
                            name="pesquisar"
                            InputLabelProps={{shrink: true}}                            
                        />
                        <FormHelperText>
                            {errors.pesquisar && <span> {errors.pesquisar.message} </span>}
                        </FormHelperText>   
                        </FormControl>                       
                    </GridItem>
               </GridContainer>
                                 
               <GridContainer> 
               {itensVenda.length > 0 && itensVenda.map(item => (   
                    <GridItem xs={12} sm={6} md={4} key={item.id}>
                        <div className={classes.boxItem} style={{marginBottom:'15px'}}>      
                        {item.tipoItem === 2 &&
                            <a href="#"><Pageview className={classes.detailItem} 
                            onClick={() => { loadDetalhePacote(item.id) }} />
                            </a>
                        }                                        
                            <div className={classes.titleItem}>
                                <h5>{item.descricao}</h5>
                                {
                                    item.tipoItem === 0 &&
                                    <label> 
                                        {t('label.product').toUpperCase()}
                                    </label>
                                }
                                {
                                    item.tipoItem === 1 &&
                                    <label> 
                                        {t('label.service').toUpperCase()}
                                    </label>
                                }
                                {
                                    item.tipoItem === 2 &&
                                    <label> 
                                        {t('label.package').toUpperCase()}  
                                    </label>
                                }                                
                            </div>
                            <h3 className={classes.valueItem}>{t('label.money_symbol')} {transformValueFloattoFormated(item.valor)}</h3>
                            <center>
                                {
                                    item.tipoItem === 0 && 
                                    item.controlaEstoque === true && 
                                    item.saldoEstoque === 0 ? 
                                    (
                                        <div className={classes.btnSemEstoque}>
                                            <span>
                                                SEM ESTOQUE
                                            </span>
                                        </div>
                                    ) : 
                                    (
                                        <Button 
                                            color="primary" 
                                            size='sm' 
                                            onClick={() => handleAdd(item)}>
                                            {t('sale.add_to_cart')}
                                        </Button>
                                    )
                                }   
                            </center>  
                        </div>
                    </GridItem>
                ))} 

                </GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <center>
                    {pages.length > 0 &&
                        <Pagination 
                        pages={pages}                       
                        color="primary"             
                        />
                    }
                    </center>
                </GridItem>
            </CardBody>
            </Card>
            </GridItem>
        </GridContainer>
       
       <Dialog open={showAddCar} TransitionComponent={Transition}>
            <DialogTitle  disableTypography className={classes.titleModalAdd} >
                <h4>{t('label.add')} </h4>                
                <Button justIcon  color="transparent" onClick={() => setshowAddCar(false)}>
                <Close />
                </Button>
            </DialogTitle>
            <DialogContent className={classes.dialogbackgroundwhite}>   
            <div className={classes.sizeModalAdd}>
               <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>                        
                        <div className={classes.titleItemModalAdd}>
                            <h5>{addItem.descricao}</h5>
                            {
                                (addItem.tipoItem === 0 && addItem.controlaEstoque === true) && 
                                <span className={classes.textGray}>
                                    Estoque: {addItem.saldoEstoque}
                                </span>
                            }
                        </div>                        
                        <label className={classes.valueItemModalAdd}> 
                            {t('label.money_symbol')} {transformValueFloattoFormated(addItem.valor===undefined ? 0 : addItem.valor)}
                        </label>
                        <Clearfix></Clearfix>
                        <br/>   
                    </GridItem>
                </GridContainer>
                <GridContainer>
                   <GridItem xs={12} sm={5} md={5}>
                    <FormControl fullWidth>
                        <TextField
                            label="QTD"
                            variant="outlined"
                            InputLabelProps={{shrink: true}} 
                            defaultValue={1}  
                            name="qtditem"       
                            type="number"     
                            onChange={(e) => handleChangeQtdItemAdd(e)}                                               
                            inputProps={{maxLength: 3}} 
                            onInput={(e) => MaskOnlyNumbersStart1(e) }          
                            inputRef={register({required: true})}
                            error={errors.qtditem?true:false} 
                        />
                        <FormHelperText>
                            {errors.qtditem && <span>{t('label.required')}</span>}
                        </FormHelperText>   
                    </FormControl>   
                   </GridItem>
                   <GridItem xs={12} sm={7} md={7}>
                    <FormControl fullWidth>
                        <TextField
                            label={t('label.money_symbol') +" "+ t('label.discount')}
                            variant="outlined"
                            InputLabelProps={{shrink: true}} 
                            defaultValue={'0,00'}
                            name="valorDesconto"     
                            onBlur={(e) => handleRestDescont(e)}     
                            onChange={(e) => handleChangeDescontoItemAdd(e)}                
                            inputRef={register({required: true})}         
                            error={errors.desconto?true:false} 
                            InputProps={{ inputComponent: MaskMoney}} 
                        />
                        <FormHelperText>
                            {errors.desconto && <span>{t('label.required')}</span>}
                        </FormHelperText>   
                    </FormControl>   
                   </GridItem>
               </GridContainer>
               <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <center style={{marginTop:'10px'}}>
                           { addItem.valorDesconto > 0 &&
                            <span className={classes.discountValueModalAdd}>
                               {t('label.money_symbol')} {transformValueFloattoFormated(addItem.valorTotal===undefined ? 0 :addItem.valorTotal)}
                            </span>
                            }
                            <span className={classes.totalValueModalAdd}>
                               {t('label.money_symbol')} {transformValueFloattoFormated(addItem.valorTotalComDesconto===undefined ? 0 :addItem.valorTotalComDesconto)}
                            </span>
                        </center>
                        <br/>
                    </GridItem>                    
                    <GridItem xs={12} sm={12} md={12}>
                        <Button 
                            fullWidth 
                            color="primary"
                            onClick={() => handleAddItemCarrinho()} >
                            {t('button.car_to_add')}                   
                        </Button>
                        <br/>
                        <Link to="/adminclinic/carrinhovenda" >
                        <Button 
                            fullWidth 
                            onClick={() => handleAddItemCarrinho()} >
                            {t('button.checkout')} 
                        </Button>
                        </Link>
                    </GridItem>
                </GridContainer>
            </div>                          

            </DialogContent>
        </Dialog>

        <Dialog open={showDetalhe} TransitionComponent={Transition}>
            <DialogTitle disableTypography className={classes.titleModalDetail}>
                <h4>{t('sale.package_detail')} </h4>                
                <Button justIcon color="transparent" onClick={() => setshowDetalhe(false)}>
                <Close />
                </Button>
            </DialogTitle>
            <DialogContent >    
            <div className={classes.sizeModalDetail}>  
                <b>{t('sale.package_included_items')}:</b> <br/> <br/>
                {detalhePacote.map(item => (                  
                    <p key={item.descricao}>{item.qtd} {item.descricao} - {t('label.money_symbol')} {transformValueFloattoFormated(item.valor)} // {item.tipoDetalheDescricao}</p>                 
                ))} 
            </div>                         

            </DialogContent>
        </Dialog>
    </div>
);
}